import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { UIElementsModule } from '@flexus/ui-elements';
import { UICompositesModule } from '@flexus/ui-composites';
import { NgSlimScrollModule } from 'ngx-slimscroll';
import { PipesModule } from '@flexus/pipes';
import { FLXRemindersComponent } from './reminders.component';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [FLXRemindersComponent],
	exports: [FLXRemindersComponent],
	imports: [CommonModule, ReactiveFormsModule, UIElementsModule, UICompositesModule, NgSlimScrollModule, PipesModule]
})
export class RemindersPluginModule {}
